import React, { useEffect, useRef } from "react";
import { Rect, Transformer } from "react-konva";

export default function EditableRect({ shape, selected, onSelect, onChange }) {
  const ref = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (selected && trRef.current && ref.current) {
      trRef.current.nodes([ref.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [selected]);

  if (!shape) return null;

  return (
    <>
      <Rect
        ref={ref}
        x={shape.x - shape.w / 2}
        y={shape.y - shape.h / 2}
        width={shape.w}
        height={shape.h}
        fill="rgba(255,255,255,0.06)"
        stroke="rgba(255,255,255,0.25)"
        strokeWidth={1}
        draggable
        onClick={onSelect}
        onTap={onSelect}
        onDragEnd={(e) => {
          const x = e.target.x() + shape.w / 2;
          const y = e.target.y() + shape.h / 2;
          onChange({ ...shape, x, y });
        }}
        onTransformEnd={() => {
          const node = ref.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          const newW = Math.max(10, node.width() * scaleX);
          const newH = Math.max(10, node.height() * scaleY);

          node.scaleX(1);
          node.scaleY(1);

          onChange({
            ...shape,
            w: newW,
            h: newH,
            x: node.x() + newW / 2,
            y: node.y() + newH / 2,
          });
        }}
      />

      {selected && (
        <Transformer
          ref={trRef}
          rotateEnabled={false}
          borderStroke="#6EE7B7"
          anchorStroke="#6EE7B7"
        />
      )}
    </>
  );
}
